import {Observable, ReplaySubject} from 'rxjs';
import {Response} from '@angular/http';
import {Model} from './model.class';
import {Service} from './service.class';
import {IdentifiedModel} from './identified-model.class';
import ProjectionInformation = Model.ProjectionInformation;

/**
 * Created by Rodrigo Quesada on 04/12/16.
 */
export class IdentifiedModelListService<T extends IdentifiedModel<T>> {

    private _service: Service;

    private _changesSubject$ = new ReplaySubject<boolean>(1);
    changes$: Observable<boolean> = this._changesSubject$;

    constructor(svcm: Service.InjectedMembers, namespace: string, protected readonly _modelType: Model.Type<T>, private readonly _basePath: string) {
        this._service = new Service(svcm, namespace);
    }

    getCurrentUserModelEntryList(projection?: ProjectionInformation): Observable<Array<T>> {
        return this._service.getList(this._modelType, this._basePath, projection);
    }

    updateCurrentUserModelEntry(model: T): Observable<Response> {
        return this._service.update(model, this._pathFor(model)).do(() => this._changesSubject$.next(true));
    }

    deleteCurrentUserModelEntry(model: T): Observable<Response> {
        return this._service.delete(this._modelType, this._pathFor(model)).do(() => this._changesSubject$.next(true));
    }

    countCurrentUserModelEntries(): Observable<number> {
        return this._service.count(this._modelType, this._basePath);
    }

    private _pathFor(model: T) {
        return model.id !== undefined ? `${this._basePath}/${model.id}` : this._basePath;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/common/identified-model-list.service.ts